// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","my-credit":"Footer_my-credit__6rxx+","credits":"Footer_credits__h0xcY"};